import { CURRENCY_SIGNS_DICTIONARY, QUOTE_STATUSES_PROVIDER } from '../../config/settings/constants'
import { formatTypeCurrency } from '../../modules/utils/formatTypeCurrency'

/**
 * To check maximum days.
 */
export const checkMaxDays = (maxDays, customMessage) => value =>
  value > maxDays ? customMessage || `El número máximo no puede superar los ${maxDays} días` : ''

/**
 * To check maximum amount 30 UTM.
 */
export const checkMaximumAmount = (exchangeRates, currencyType, maxAmountsUTMs, customMessage) => value => {
  const aux = value.replace(/[^0-9,]/g, '').replace(',', '.')
  const amount = parseFloat(
    formatTypeCurrency(currencyType, aux)
      .replace(/[^0-9,]/g, '')
      .replace(',', '.')
  )
  const currentExchangeRate = exchangeRates.find(exchangeRate => exchangeRate.value === currencyType)
  const convertAmount = currentExchangeRate?.clpAmount * amount
  const rawAmount = currencyType === CURRENCY_SIGNS_DICTIONARY.CLP ? amount : convertAmount
  const currentExchangeRateUTM = exchangeRates.find(exchangeRate => exchangeRate.value === 'UTM')
  const maximumAmount = parseInt(currentExchangeRateUTM?.clpAmount || 0, 10) * parseInt(maxAmountsUTMs, 10)
  return rawAmount > maximumAmount
    ? customMessage || `El monto total cotizado no debe superar las ${maxAmountsUTMs} UTM.`
    : ''
}

export const checkInputErrorMinValue = (minValue, customMessage) => value => {
  return value < minValue ? customMessage || `El monto total cotizado no debe ser inferior a ${minValue}.` : ''
}
/**
 * Method that assigns the status of the supplier in text
 *
 * @param {boolean} isEnabled
 * @param {boolean} isCurrentAccreditation
 * @returns
 */
export const checkStatusProviderValue = (isEnabled, isCurrentAccreditation) => {
  if (!isCurrentAccreditation) {
    return QUOTE_STATUSES_PROVIDER.UNACREDITED
  }

  if (isEnabled) return QUOTE_STATUSES_PROVIDER.ENABLED
  if (isEnabled === false) return QUOTE_STATUSES_PROVIDER.DISABLED
  if (isEnabled === null) return QUOTE_STATUSES_PROVIDER.IN_PROGRESS

  return ''
}
